import { AnyAction } from 'redux'
import { connect, ConnectedProps } from 'react-redux'
import { produce } from 'immer'
import { RootState } from '../../../store'
import { PanelProps } from './Panel'

interface PanelState {
  sidebar: boolean
}

export type PanelStateProps = ConnectedProps<typeof connector>

const intialState: PanelState = {
  sidebar: false
}

const actions = {
  sidebarClose: 'admin/panel/sidebarOpen',
  sidebarOpen: 'admin/panel/sidebarClose',
  sidebarRoute: 'admin/panel/sidebarRoute'
}

export default function reducers (state = intialState, action: AnyAction) {
  switch (action.type) {
    case actions.sidebarOpen:
      return produce(state, draft => {
        draft.sidebar = true
      })
    case actions.sidebarClose:
      return produce(state, draft => {
        draft.sidebar = false
      })
    case actions.sidebarRoute:
      return produce(state, draft => {
        draft.sidebar = false
      })
    default:
      return state
  }
}

const mapDispatchToProps = {
  sidebarOpen () {
    return { type: actions.sidebarOpen }
  },
  sidebarClose () {
    return { type: actions.sidebarClose }
  },
  sidebarRoute () {
    return { type: actions.sidebarRoute }
  }
}

function mapStateToProps (state: RootState, props: PanelProps) {
  return produce(state.adminPanel, draft => draft)
}

export const connector = connect(mapStateToProps, mapDispatchToProps)
